<!-- <ngx-loading
      [show]="isLoading"
      [config]="{
        backdropBorderRadius: '3px'
      }"

    ></ngx-loading> -->
<app-loading [isLoading]="isLoading"></app-loading>

<div class="mc-flex">
  <div class="header">
    <div class="system">
      <div class="container-fluid">
        <img src="/assets/my-channel-app-icon.png" class="icon" />
        <div class="overlay">MYCHANNEL ADMIN</div>
        <div class="clearfix"></div>
      </div>
    </div>

    <div class="info">
      <div class="container-fluid">
        <small>
          <i class="bi bi-person"></i> {{ user?.username }}
        </small>
        <small class="pl-5">
          <i class="bi bi-box-arrow-right mr-2"></i>
          <a href="#" class="text-white" id="sign-out" (click)="$event.preventDefault(); onSignOut();">
            LOG OUT
          </a>
        </small>
      </div>
    </div>
  </div>

  <div class="wrapper">
    <div class="slidebar">

      <!-- Sidebar -->
      <nav id="sidebar">
        <div class="sidebar-header" style="background-color: #74a822;" (click)="goToHome()">
          <h5 class="m-0">
            <i class="bi bi-list"></i> MENU
          </h5>
        </div>

        <!-- <ul class="list-unstyled">
          <li *ngFor="let menu of menus" routerLinkActive="active">
            <a href="#{{ menu?.titleTh }}"  data-toggle="collapse" aria-expanded="false" [routerLink]="menu?.link">
              <i class="fa fa-chevron-right"></i>
              {{ menu?.titleTh }}
            </a>
          </li>
        </ul>
      </nav> -->
      <!-- <ul class="list-unstyled">
        <li *ngFor="let menu of menus;let i=index" routerLinkActive="active">
          <ng-container *ngIf="menu.permission.read && ((menu?.menu === 'Monitor Order' && isMonitorOrder) || menu?.menu !== 'Monitor Order')">
            <a id="nav-menu{{i}}" style="cursor: pointer;" (click)="onChangeMenu(menu?.link, i)" data-toggle="collapse" aria-expanded="false">
              <i class="bi bi-chevron-right"></i>
              {{ menu?.menu }}
            </a>
          </ng-container>
          <ng-container *ngIf="!menu.permission.read && ((menu?.menu === 'Monitor Order' && isMonitorOrder) || menu?.menu !== 'Monitor Order')">
            <a id="nav-menu" (click)="onChangeMenu(menu?.menu)" style="cursor: pointer;" data-toggle="collapse" aria-expanded="false">
              <i class="bi bi-chevron-right"></i>
              {{ menu?.menu }}
            </a>
          </ng-container>
          <ul class="list-unstyled" id="{{ menu?.menu }}" *ngIf="(menu?.submenu != 'ALL' && isMonitorOrder) || menu?.submenu !== 'ALL'">
            <ng-container *ngIf="menu?.subMenu">
              <li *ngFor="let submenu of menu?.subMenu; let idx=index">

                <a id="nav-submenu{{idx}}" (click)="onChangeSubMenu(menu.link+submenu?.sublink, idx, menu.subMenu,i)" style="padding-left: 30px;cursor: pointer;">
                    <i class="bi bi-chevron-right"></i>
                    {{submenu.subName}}
                </a>
              </li>
            </ng-container>

          </ul>
        </li>
      </ul> -->
      <ul class="list-unstyled">
        <li *ngFor="let menu of menus;let i=index" routerLinkActive="active">
          <ng-container *ngIf="menu.permission.read">
            <a id="nav-menu{{i}}" style="cursor: pointer;" (click)="onChangeMenu(menu?.link, i,menu.submenu)" data-toggle="collapse" aria-expanded="false">
              <i class="bi bi-chevron-right"></i>
              {{ menu?.menu }}
            </a>
          </ng-container>
          <!-- <ng-container *ngIf="!menu.permission.read && !menu.permission.create && !menu.permission.update && !menu.permission.delete">
          </ng-container> -->
          <ng-container *ngIf="!menu.permission.read && (menu.permission.create || menu.permission.update || menu.permission.delete)">
            <a id="nav-menu{{i}}" style="cursor: pointer;" (click)="onChangeMenu(menu?.link, i,menu.submenu)" data-toggle="collapse" aria-expanded="false">
              <i class="bi bi-chevron-right"></i>
              {{ menu?.menu }}
            </a>
          </ng-container>
          <ul class="list-unstyled" id="{{ menu?.menu }}" *ngIf="(menu?.submenu != 'ALL' && isMonitorOrder) || menu?.submenu !== 'ALL'">
            <ng-container *ngIf="menu?.data">
              <li *ngFor="let submenu of menu?.data; let idx=index">
                <a id="nav-submenu{{submenu?.sublink}}" (click)="onChangeSubMenu(submenu.link+submenu?.sublink, idx, menu.data,i,submenu?.sublink)" style="padding-left: 30px;cursor: pointer;">
                    <i class="bi bi-chevron-right"></i>
                    {{submenu.subName}}
                </a>
              </li>
            </ng-container>

          </ul>
        </li>
      </ul>
    </nav>

    </div>
    <div class="content">
      <div class="mt-3">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>

<!-- <div class="wrapper"><div class="header">
  <div class="system">
    <div class="container-fluid">
      <img src="/assets/my-channel-app-icon.png" class="icon" />
      <div class="overlay">MYCHANNEL ADMIN</div>
      <div class="clearfix"></div>
    </div>
  </div>

  <div class="info">
    <div class="container-fluid">
      <small>
        <i class="fa fa-user-o mr-2"></i> {{ user?.username }}
      </small>
      <small class="pl-5">
        <i class="fa fa-sign-out mr-2"></i>
        <a href="#" class="text-white" (click)="$event.preventDefault(); onSignOut();">
          LOG OUT
        </a>
      </small>
    </div>
  </div>
</div>


  <div class="slidebar">side bar</div>
  <div class="col-6">content</div>
</div> -->